import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import S from 'StyledAccountFreebet.js';
import Loader from 'Loader.js';
import Datepicker from 'Datepicker.js';
import Pagination from 'Pagination.js';
import _map from 'lodash/map';
import _size from 'lodash/size';
import _get from 'lodash/get';
import { translation } from 'helpers/utilsHelper.js';
import { formatDate } from 'helpers/datesHelper.js';
import {
  changeDateByType,
  fetchFreebetsByFilter,
  setCurrentPage,
  fetchAllFreebets,
} from 'accountFreebetActions.js';
import { proccessFrontError } from 'errorActions.js';

class AccountFreebet extends Component {
  componentDidMount = async () => {
    const { fetchFreebetsByFilter, processFrontError } = this.props;
    try {
      await fetchFreebetsByFilter();
    } catch (error) {
      processFrontError(error, 'AccountFreebet.componentDidMount');
    }
  };

  handleChangeStart = (date) => {
    const { changeDateByType, fetchFreebetsByFilter } = this.props;
    const startDate = new Date(date);

    batch(() => {
      changeDateByType('startDate', startDate);
      fetchFreebetsByFilter({ startDate });
    });
  };

  handleChangeEnd = (date) => {
    const { changeDateByType, fetchFreebetsByFilter } = this.props;
    const endDate = new Date(date);

    batch(() => {
      changeDateByType('endDate', endDate);
      fetchFreebetsByFilter({ endDate });
    });
  };

  onChangeFilter = (activeTab) => {
    const { changeActiveTab, fetchFreebetsByFilter } = this.props;

    batch(() => {
      changeActiveTab(activeTab);
      fetchFreebetsByFilter({ activeTab });
    });
  };

  goPage = (currentPage, activeTab) => {
    const { fetchFreebetsByFilter, setCurrentPage, processFrontError } = this.props;
    try {
      batch(() => {
        setCurrentPage(currentPage, activeTab);
        fetchFreebetsByFilter();
      });
    } catch (error) {
      processFrontError(error, 'AccountFreebet.goPage');
    }
  };

  render() {
    const { isPending, startDate, endDate, freebets, limit, currencyCode } = this.props;
    const {
      data: activeFreebetsData,
      currentPage: activeFreebetsCurrentPage,
      isNextPageAvailable: activeFreebetsIsNextPageAvailable,
    } = freebets.active;
    const {
      data: historyFreebetsData,
      currentPage: historyFreebetsCurrentPage,
      isNextPageAvailable: historyFreebetsIsNextPageAvailable,
    } = freebets.history;

    return (
      <S.AccountFreebet>
        <S.FreebetFilters className="freebet-filters">
          <S.FreebetFiltersDates className="freebet-filters-dates">
            <S.DateWrapper className="date-wrapper">
              <S.DateLabel>{translation('common_dateFrom')}</S.DateLabel>
              <Datepicker
                selected={startDate}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                dateFormat="yyyy-MM-dd"
                cb={this.handleChangeStart}
              />
              <S.DateIcon className="ion ion-ios-calendar-outline"></S.DateIcon>
            </S.DateWrapper>

            <S.DateWrapper className="date-wrapper">
              <S.DateLabel>{translation('common_dateTo')}</S.DateLabel>
              <Datepicker
                selected={endDate}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                dateFormat="yyyy-MM-dd"
                cb={this.handleChangeEnd}
              />
              <S.DateIcon className="ion ion-ios-calendar-outline"></S.DateIcon>
            </S.DateWrapper>
          </S.FreebetFiltersDates>
        </S.FreebetFilters>

        <S.FreebetList>
          {isPending ? (
            <Loader />
          ) : (
            <>
              <S.FreebetActiveList className="freebet-active-list">
                <S.FreebetListHeader>
                  {translation('account_freebets_active_header')}
                </S.FreebetListHeader>

                <S.FreebetFakeTable>
                  <S.Thead>
                    <S.Tr>
                      <S.Th className="th freebet_id">
                        <span>{translation('account_freebets_freebetId')}</span>
                      </S.Th>
                      <S.Th className="th freebet_ammount">
                        <span>{translation('account_freebets_freebetAmount')}</span>
                      </S.Th>
                      <S.Th className="th freebet_name">
                        <span>{translation('account_freebets_freebetName')}</span>
                      </S.Th>
                      <S.Th className="th freebet_expirationDate">
                        <span>{translation('account_freebets_freebetExpirationDate')}</span>
                      </S.Th>
                    </S.Tr>
                  </S.Thead>
                  <S.Tbody>
                    {activeFreebetsData.length > 0 ? (
                      <>
                        {activeFreebetsData.map(
                          ({ validTo, nameKey, offerFreebetId, freebetStake }) => {
                            return (
                              <S.Tr className="row-flex" key={offerFreebetId}>
                                <S.Td className="td freebet-id">
                                  <span>{offerFreebetId}</span>
                                </S.Td>
                                <S.Td className="td freebet-ammount">
                                  <span className="ammount">{freebetStake.toFixed(2)}</span>&nbsp;
                                  <span className="currency">{currencyCode}</span>
                                </S.Td>
                                <S.Td className="td freebet-name">
                                  <span>{translation(nameKey)}</span>
                                </S.Td>
                                <S.Td className="td freebet-expirationDate">
                                  <span>{formatDate(validTo, 'yyyy-MM-dd HH:mm')}</span>
                                </S.Td>
                              </S.Tr>
                            );
                          }
                        )}

                        <Pagination
                          {...{
                            currentPage: activeFreebetsCurrentPage,
                            limit,
                            data: activeFreebetsData,
                            isNextPageAvailable: activeFreebetsIsNextPageAvailable,
                            callback: (currentPage) => this.goPage(currentPage, 'active'),
                          }}
                        />
                      </>
                    ) : (
                      <S.NoResult>{translation('account_freebets_noActiveFreebets')}</S.NoResult>
                    )}
                  </S.Tbody>
                </S.FreebetFakeTable>
              </S.FreebetActiveList>
              <S.FreebetHistoryList className="freebet-history-list">
                <S.FreebetListHeader>
                  {translation('account_freebets_history_header')}
                </S.FreebetListHeader>

                <S.FreebetFakeTable>
                  <S.Thead>
                    <S.Tr>
                      <S.Th className="th freebet_id">
                        <span>{translation('account_freebets_freebetId')}</span>
                      </S.Th>
                      <S.Th className="th freebet_ammount">
                        <span>{translation('account_freebets_freebetAmount')}</span>
                      </S.Th>
                      <S.Th className="th freebet_name">
                        <span>{translation('account_freebets_freebetName')}</span>
                      </S.Th>
                      <S.Th className="th freebet_expirationDate">
                        <span>{translation('account_freebets_freebetExpirationDate')}</span>
                      </S.Th>
                    </S.Tr>
                  </S.Thead>

                  <S.Tbody>
                    {historyFreebetsData.length > 0 ? (
                      <>
                        {historyFreebetsData.map(
                          ({ validTo, nameKey, offerFreebetId, freebetStake }) => {
                            return (
                              <S.Tr className="row-flex" key={offerFreebetId}>
                                <S.Td className="td freebet-id">
                                  <span>{offerFreebetId}</span>
                                </S.Td>
                                <S.Td className="td freebet-ammount">
                                  <span className="ammount">{freebetStake.toFixed(2)}</span>&nbsp;
                                  <span className="currency">{currencyCode}</span>
                                </S.Td>
                                <S.Td className="td freebet-name">
                                  <span>{translation(nameKey)}</span>
                                </S.Td>
                                <S.Td className="td freebet-expirationDate">
                                  <span>{formatDate(validTo, 'yyyy-MM-dd HH:mm')}</span>
                                </S.Td>
                              </S.Tr>
                            );
                          }
                        )}
                        <Pagination
                          {...{
                            currentPage: historyFreebetsCurrentPage,
                            limit,
                            data: historyFreebetsData,
                            isNextPageAvailable: historyFreebetsIsNextPageAvailable,
                            callback: (currentPage) => this.goPage(currentPage, 'history'),
                          }}
                        />
                      </>
                    ) : (
                      <S.NoResult>{translation('account_freebets_noHistoryFreebets')}</S.NoResult>
                    )}
                  </S.Tbody>
                </S.FreebetFakeTable>
              </S.FreebetHistoryList>
            </>
          )}
        </S.FreebetList>
      </S.AccountFreebet>
    );
  }
}

const mapStateToProps = ({
  AccountFreebet: { isPending, error, startDate, endDate, freebets, limit },
  Auth: {
    user: { currencyCode },
  },
}) => {
  return {
    error,
    isPending,
    startDate,
    endDate,
    freebets,
    limit,
    currencyCode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeDateByType: bindActionCreators(changeDateByType, dispatch),
    fetchFreebetsByFilter: bindActionCreators(fetchFreebetsByFilter, dispatch),
    setCurrentPage: bindActionCreators(setCurrentPage, dispatch),
    fetchAllFreebets: bindActionCreators(fetchAllFreebets, dispatch),
    processFrontError: bindActionCreators(proccessFrontError, dispatch),
    dispatch,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AccountFreebet);
